export const iconFontAwesomeMoneyYenSign = (
	<i className="fa-solid fa-yen-sign"></i>
);
